interface AddBlockBarProps {
  /** e.g. "Add a section" / "Add a divider". */
  title: string;
  onCancel: () => void;
}

/** Mode bar shown over the preview while choosing where a block goes. */
export default function AddBlockBar({ title, onCancel }: AddBlockBarProps) {
  return (
    <div className="flex items-center justify-between rounded-lg bg-zinc-900 py-2.5 pr-2.5 pl-4 text-white shadow-lg">
      <span className="text-sm">{title}</span>
      <button
        type="button"
        onClick={onCancel}
        className="rounded-lg border border-zinc-600 bg-zinc-800 px-4 py-1.5 text-sm hover:bg-zinc-700"
      >
        Cancel
      </button>
    </div>
  );
}
